import * as React from 'react';
import { connect } from 'react-redux';
import Button from 'antd/lib/button';
import { LogoutOutlined } from '@ant-design/icons';
import { bindActionCreators, Dispatch } from 'redux';

import { LoginActionCreators as BaseLoginActionCreators, LoginState as BaseLoginState, getActionCreators } from '@common/react/store/Login';
import { BaseUser } from '@common/react/objects/BaseUser';
import { BaseApplicationState } from '@common/react/store';

interface OwnProps {
	render?: (logout: (event: React.MouseEvent) => void) => JSX.Element;
	clearState?: boolean;
}

interface ReduxProps {
	actions: BaseLoginActionCreators<BaseUser, BaseApplicationState<BaseUser>>;
}

type LoginState = BaseLoginState<BaseUser>;

type LogoutProps =
	LoginState
	& ReduxProps
	& OwnProps;

class LogoutInner extends React.Component<LogoutProps> {
	logout = (event: React.MouseEvent) => {
		event.preventDefault();
		this.props.actions.logoff(this.props.clearState);
	};

	public render() {
		const { render } = this.props;
		const loading = this.props.isLoading;

		return render ? render(this.logout) : (
			<Button
				type="text"
				onClick={this.logout}
				className="logout-component"
				icon={<LogoutOutlined />}
				size="small"
				loading={loading}
			>
				Logout
			</Button>
		);
	}
}

type StateProps = LoginState;

export const Logout = connect<
	StateProps,
	ReduxProps,
	OwnProps,
	BaseApplicationState<BaseUser>
>(
	(state) => ({
		...state.login,
	}),
	(dispatch: Dispatch) => ({
		actions: bindActionCreators(getActionCreators(), dispatch),
	}),
)(LogoutInner);
